(function (window) {
  window.caseplayDisplayTitle = function (productTitle, productNameTag) {
    // Preparation
    var language = document.documentElement.lang || '';
    var languageCode = language.split('-')[0].toLowerCase();
    var isEnglish = languageCode === 'en';
    var normalizedTitle = String(productTitle || '');
    var normalizedTag = String(productNameTag || '');
    var japaneseTitle = normalizedTag;
    var designNameMatch = null;

    if (normalizedTag.indexOf('productname_') === 0) {
      japaneseTitle = normalizedTag.replace('productname_', '');
    }

    if (isEnglish && normalizedTitle) {
      designNameMatch = normalizedTitle.match(/\[([^\]]+)\]|［([^］]+)］/);
    }

    // Fallback ladder
    if (designNameMatch) {
      return (designNameMatch[1] || designNameMatch[2]).trim();
    }

    if (japaneseTitle) {
      return japaneseTitle;
    }

    if (normalizedTitle) {
      return normalizedTitle;
    }

    return '';
  };
})(window);
